// extracted by mini-css-extract-plugin
export default {"Vcard":"VirtualAccount_Vcard__Yo-5K","VAcctTxt":"VirtualAccount_VAcctTxt__xFvuF","VFundTxt":"VirtualAccount_VFundTxt__Nb1c+","VBank":"VirtualAccount_VBank__Qp63w"};